import { Button, Card, Elevation, Intent, Tag } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import styled from "styled-components";

import { SectionHeading } from "./styled/fragments";

const ServiceCard = styled(Card)`
	display: grid;
	grid-template:
    ' top right ' auto
    ' left right ' auto
    / 1fr auto;
	margin-bottom: 20px;
	grid-gap: 0.8em;
	
	.left-pad {
		display: flex;
		align-items: center;
		
		& > *:first-child {
			margin-right: 10px;
		}
	}
	
	.title {
		grid-area: top;
		font-size: 1.1em;
		
		.status {
			font-size: 12px;
		}
	}
	
	.impl {
		grid-area: left;
		font-size: 0.95em;
		
		.bp3-code-block {
			margin: 0;
			padding: 0.6em;
			font-size: 1em;
		}
	}
	
	.details {
		grid-area: right;
    	display: grid;
    	grid-gap: 5px;
   		align-items: center;
	}
`;

const renderCard = ({title, implPath}) => (
	<ServiceCard elevation={Elevation.ONE}>
		<div className="title left-pad">
			<div>{title}</div>
			<Tag intent={Intent.SUCCESS}>Active</Tag>
		</div>
		<div className="impl left-pad">
			<div>Implementation</div>
			<div className="bp3-code-block">{implPath}</div>
		</div>
		<div className="details">
			<Button icon={IconNames.INFO_SIGN}>Details</Button>
			<Button icon={IconNames.CHART}>Metrics</Button>
		</div>
	</ServiceCard>
)

// TODO connect this to ServiceRegistry
const ServicesPanel: React.SFC = () => (
	<div>
		<SectionHeading title="Services" />
		{renderCard({title: "Query Service", implPath: "/src/core/service/query/impl/Query.service.ts"})}
		{renderCard({title: "Mutation Service", implPath: "/src/core/service/query/impl/Query.service.ts"})}
		{renderCard({title: "Resolver Service", implPath: "/src/core/service/query/impl/Query.service.ts"})}
		{renderCard({title: "Local Storage Service", implPath: "/src/core/service/query/impl/Query.service.ts"})}
		{renderCard({title: "Logger Service", implPath: "/src/core/service/query/impl/Query.service.ts"})}
	</div>
)

export default ServicesPanel;



// WEBPACK FOOTER //
// ./src/core/components/editor/ServicesPanel.tsx